// extracted by mini-css-extract-plugin
export default {"quote":"juhwgaWZIs5BObwFiYnm","section":"i_n5UTqaET6BJmH0u18F"};